// Doit correspondre aux actifs côté serveur (server/src/shared/constants.ts)
export const MARKET_ASSETS = [
	"SP500",
	"QQQ",
	"TSX",
	"GLD",
	"TLT",
] as const;
